<style lang="scss" scoped>
  .new-b2c-qc-report-tab {
    border-radius: 4px;

    .report-tab-tt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 48px;

      .tt {
        color: #111;
        font-weight: 500;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
      }

      .con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #111111;
        font-weight: 400;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 24px;

        &.hideCheckedIcon i {
          visibility: hidden;
        }

        .desc {
          color: #999;
        }

        .checked {
          color: #999;
        }

        .check-num {
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
            margin-left: 24px;
          }
        }

        .arrow {
          width: 24px;
          height: 24px;
          margin-left: 12px;
          vertical-align: top;
          transition: 0.3s;
        }

        .active-arrow {
          transform: rotateZ(180deg);
        }
      }
    }

    .content-wrap-show {
      height: auto;
      overflow: hidden;
    }

    .content-wrap-toggle {
      height: 0;
      overflow: hidden;

      &.active {
        height: auto;
        overflow: visible;
      }
    }

    .content-wrap-antoggle {
      height: auto;

      &.active {
        height: 0;
        overflow: hidden;
      }
    }
  }
</style>

<template>
  <div class="new-b2c-qc-report-tab">
    <div class="report-tab-tt" @click="ttClick">
      <span class="tt">{{ title }}</span>
      <div class="con" :class="{ hideCheckedIcon: !$slots.default }">
        <div v-if="checkText" class="checked">{{ checkText }}</div>
        <template v-if="checkNumMap">
          <div class="check-num normal">
            <img
              v-if="checkNumMap.normalNum || checkNumMap.allPassText"
              src="https://pic3.zhuanstatic.com/zhuanzh/96c9be24-3030-4345-9ae7-0585942af299.png"
            />
            <span>
              {{
                checkNumMap.abNormalNum
                  ? `${checkNumMap.normalNum}项`
                  : checkNumMap.allPassText || `${checkNumMap.normalNum}项`
              }}
            </span>
          </div>
          <div v-if="!!checkNumMap.abNormalNum" class="check-num ab-normal">
            <img
              src="https://pic4.zhuanstatic.com/zhuanzh/a3ee35c7-0fe8-4398-950e-77f33668f9d2.png"
            />
            <span>{{ checkNumMap.abNormalNum }}项</span>
          </div>
        </template>

        <span v-if="desc" class="desc">{{ desc }}</span>
        <img
          v-if="checkNumMap.normalNum"
          src="https://pic6.zhuanstatic.com/zhuanzh/149b0575-cfc4-4814-bcc7-6427b0d1d285.png"
          :class="['arrow', { 'active-arrow': active }]"
        />
      </div>
    </div>
    <div class="content-wrap-show">
      <slot name="show"></slot>
    </div>
    <div class="content-wrap-toggle" :class="{ active }">
      <slot name="toggle"></slot>
    </div>
    <div class="content-wrap-antoggle" :class="{ active }">
      <slot name="antoggle"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: '转转',
      },
      expanded: {
        type: Boolean,
        default: false,
      },
      checkText: {
        type: String,
        default: '',
      },
      desc: {
        type: String,
        default: '',
      },
      checkNumMap: {
        type: Object,
        default: null,
      },
      haveIcon: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        active: false,
      }
    },
    mounted() {
      this.active = this.expanded
    },
    methods: {
      ttClick() {
        this.active = !this.active
      },
    },
  }
</script>
